export const actionTypes = {
    POST_CHECKOUT: 'POST_CHECKOUT',
    POST_CHECKOUT_SUCCESS: 'POST_CHECKOUT_SUCCESS',
    POST_CHECKOUT_FAIL: 'POST_CHECKOUT_FAIL',

    CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    CANCEL_SUBSCRIPTION_SUCCESS: 'CANCEL_SUBSCRIPTION_SUCCESS',
    CANCEL_SUBSCRIPTION_FAIL: 'CANCEL_SUBSCRIPTION_FAIL',

    RESUME_SUBSCRIPTION: 'RESUME_SUBSCRIPTION',
    RESUME_SUBSCRIPTION_SUCCESS: 'RESUME_SUBSCRIPTION_SUCCESS',
    RESUME_SUBSCRIPTION_FAIL: 'RESUME_SUBSCRIPTION_FAIL',

    CLEAR_SUBSCRIPTION: "CLEAR_SUBSCRIPTION"
  };
  
  export const actions = {
    checkoutSubscription: () => ({
      type: actionTypes.POST_CHECKOUT,
    }),
    checkoutSubscriptionSuccess: (data: any) => ({
      type: actionTypes.POST_CHECKOUT_SUCCESS,
      payload: data,
    }),
    checkoutSubscriptionFail: (err: any) => ({
      type: actionTypes.POST_CHECKOUT_FAIL,
      payload: err,
    }),

    cancelSubscription: () => ({
      type: actionTypes.CANCEL_SUBSCRIPTION,
    }),
    cancelSubscriptionSuccess: () => ({
      type: actionTypes.CANCEL_SUBSCRIPTION_SUCCESS,
    }),
    cancelSubscriptionFail: (err: any) => ({
      type: actionTypes.CANCEL_SUBSCRIPTION_FAIL,
      payload: err,
    }),

    resumeSubscription: () => ({
      type: actionTypes.RESUME_SUBSCRIPTION,
    }),
    resumeSubscriptionSuccess: () => ({
      type: actionTypes.RESUME_SUBSCRIPTION_SUCCESS,
    }),
    resumeSubscriptionFail: (err: any) => ({
      type: actionTypes.RESUME_SUBSCRIPTION_FAIL,
      payload: err,
    }),
  
    clearCheckout: () => ({
      type: actionTypes.CLEAR_SUBSCRIPTION
    })
  };
  